


export enum AnimalTypeEnum {
	dog = 0,
	cat = 1,
}